import { Box, Tab, Typography } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import React, { useState } from 'react';

import SmsAeroSettings from '../components/SmsAeroSettings';
import CascadeMessageHistory from '../components/CascadeMessageHistory';

const Cascade = () => {
    const savedTab = localStorage.getItem('cascadeSettingsTab') || '1';
    const [value, setValue] = useState(savedTab);

    const tabs = [
        { label: 'Настройки SMS Aero', value: '1', component: <SmsAeroSettings /> },
        { label: 'История сообщений', value: '2', component: <CascadeMessageHistory /> },
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
        localStorage.setItem('cascadeSettingsTab', newValue);
    };

    // Restore tab on mount
    React.useEffect(() => {
        const savedTab = localStorage.getItem('cascadeSettingsTab');
        if (savedTab) {
            setValue(savedTab);
        }
    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant="h5" sx={{ mb: 3 }}>
                Каскадные рассылки
            </Typography>
            
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList
                        aria-label='Cascade tabs'
                        onChange={handleChange}
                        textColor='secondary'
                        indicatorColor='secondary'
                    >
                        {tabs.map((tab) => (
                            <Tab key={tab.value} label={tab.label} value={tab.value} />
                        ))}
                    </TabList>
                </Box>
                {tabs.map((tab) => (
                    <TabPanel key={tab.value} value={tab.value}>
                        {tab.component}
                    </TabPanel>
                ))}
            </TabContext>
        </Box>
    );
};

export default Cascade;